import { render, staticRenderFns } from "./SpaceInviteFromSnapshot.vue?vue&type=template&id=dbac4a98&"
import script from "./SpaceInviteFromSnapshot.vue?vue&type=script&lang=js&"
export * from "./SpaceInviteFromSnapshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports